import PT from 'prop-types';
import { LegacyButton } from 'edrolo-style-guide';

import styles from './DeleteSittingOverlay.scss';

const DeleteSittingOverlay = (props) => {
  const { overlayControl, examId, sittingId, deleteExamSitting } = props;

  return (
    <div>
      <p className={styles.deletionQuestion}>
        <strong>
          {"Are you sure you want to delete this student's exam sitting?"}
        </strong>
      </p>
      <p className={styles.deletionWarning}>
        {"Once it's gone, it can't be recovered."}
      </p>

      <div>
        <LegacyButton
          primary
          skinny
          bold
          size="small"
          onClick={() => deleteExamSitting(examId, sittingId)}
          className={styles.confirmButton}
          data-test="delete-sitting-confirm"
        >
          Yes, delete it
        </LegacyButton>
        <LegacyButton
          skinny
          size="small"
          basic
          onClick={() => overlayControl.hide()}
          className={styles.cancelButton}
        >
          No, leave it as is
        </LegacyButton>
      </div>
    </div>
  );
};

export default DeleteSittingOverlay;

DeleteSittingOverlay.propTypes = {
  overlayControl: PT.func,
  examId: PT.oneOf([PT.string, PT.number]),
  sittingId: PT.oneOf([PT.string, PT.number]),
  deleteExamSitting: PT.func,
};
